import React, { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

// Portals allow us to render components outside of the parent container e.g. at the bottom of the body tag.
// This is useful for dialogs that need to span the full width of the screen (https://reactjs.org/docs/portals.html)
interface PortalProps {
  children: ReactNode
}

export default function Portal({ children }: PortalProps) {
  const [element, setElement] = useState<HTMLDivElement>(document.createElement('div'))

  useEffect(() => {
    document.body.appendChild(element)

    return () => {
      // Remove the element when it unmounts
      document.body.removeChild(element)
    }
  }, [])

  return createPortal(children, element)
}
